
import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../primitives';
import { RevisionedLineItemSchema } from '../revisioned-line-item';

export const BaseLineItemSchema = oz.object({
  invoiceId: ObjectIdSchema,
  revisionedLineItem: RevisionedLineItemSchema.nullable(),
  price: oz.number(),
  modifiedName: oz.string().nullable(),
  modifiedDescription: oz.string().nullable(),
  percentage: oz.number().nonnegative().nullable(),
}).openapi('BaseLineItem');

export type BaseLineItem = oz.infer<typeof BaseLineItemSchema>;